import React from 'react';
import Header from './Header';
import Body from './Body';
import styles from './table.module.scss';
import classnames from 'classnames';

type Props = React.PropsWithChildren<{
  caption?: React.ReactNode;
  inContainer?: boolean;
}>;

const SimpleTable = ({caption, children, inContainer}: Props): React.ReactElement => (
  <table
    className={classnames(styles.table, {[styles.boxShadow]: inContainer})}
    data-testid="simple-table"
  >
    {caption && <caption className={styles.caption}>{caption}</caption>}
    {children}
  </table>
);

SimpleTable.Body = Body;
SimpleTable.Header = Header;

export default SimpleTable;
